import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'ridango-table-row',
    templateUrl: './table-row.component.html',
    styleUrls: ['./table-row.component.css']
})
export class TableRowComponent implements OnInit {
    @Input() isEven;
    constructor() { }

    ngOnInit() {
    }

}
